import {computed, makeObservable, observable, reaction, values} from "mobx";
import axios from "axios";
import CommonHelper from "../helper/CommonHelper";
import Sort from "./Sort";
import {debounce} from "lodash";
import React from 'react'

class MediaStore {

    constructor({url = `/list`, rowsPerPage = 40, sort = new Sort('id', Sort.SORT_DIRECTION.DESC)}) {
        makeObservable(this);
        this.url = url;
        this.rowsPerPage = rowsPerPage;
        this.sort = sort;

    }

    @observable
    isInit = true;

    @observable
    url;

    @observable page = 1;

    @observable isFetching = false;

    /**
     * 정렬 컬럼
     * @type Sort
     */
    @observable sort;

    /**
     * 현재 검색 조건
     * @type {Map}
     */
    @observable searchCondition = new Map();

    /**
     * 페이징 블럭 사이즈
     * @type {number}
     */
    paginationSize;

    /**
     * 페이지당 행 수
     * @type {number}
     */
    rowsPerPage;

    scrollRef = React.createRef();

    @observable
    scrollTop = 0;

    onScrollHandler = e => {
        let store = this;
        store.scrollTop = e.target.scrollTop;
    }

    @computed
    get searchConditionWithPage() {
        let m = CommonHelper.mapToObject(this.searchCondition);
        m.pagingOption = {
            page: this.page,
            rowsPerPage: this.rowsPerPage,
            sort: this.parameterizeSort
        };
        return m;
    }

    @computed
    get parameterizeSort() {
        return this.sort.toParam()
    }

    debounceFetch = debounce(reset => {
            this.fetch(reset)
        },500
    )

    debounceRefresh = debounce(() => {
            this.fetch(true)
        },500
    )

    fetch = async (reset = false) => {
        let store = this;
        if (store.isFetching)
            return;
        store.isFetching = true;
        if(reset){
            this.clear()
            store.page = 1;
        }else{
            store.page += 1;
        }
        let {data: {items, itemCount}} = await axios.post(`/media${this.url}`, this.searchConditionWithPage)
        store.isFetching = false;
        let originFiles = store.files
        store.isInit = false;
        store.fileMap.replace(originFiles.concat(items).map(media => [media.id, media]))
        store.count = itemCount;
        return originFiles.concat(items).map(media => [media.id, media]);
    }

    @computed
    get isMore() {
        let store = this;
        return store.files.length < store.count;
    }

    @observable
    fileMap = new Map();

    @computed
    get files() {
        return values(this.fileMap) || [];
    }

    @observable
    count = 0;

    clear() {
        this.fileMap.clear();
    }

    @computed
    get lastFile(){
        return this.files.length > 0 ? this.files[0] : null;
    }

}


const mediaStore = new MediaStore({
    url:'/list'
});

const tagMediaStore = new MediaStore({
    url:'/list',
});

export {mediaStore, tagMediaStore};
